function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Text } from "../..";
import MenuItem from '@material-ui/core/MenuItem';
import { sizeTextSizeMapping } from "./SelectComponents.styles";
export var Option = function Option(_ref) {
  var innerRef = _ref.innerRef,
      isSelected = _ref.isSelected,
      isFocused = _ref.isFocused,
      innerProps = _ref.innerProps,
      children = _ref.children,
      selectProps = _ref.selectProps;
  var size = selectProps.size;
  var textSize = sizeTextSizeMapping[size];
  return /*#__PURE__*/React.createElement(MenuItem, _extends({
    ref: innerRef,
    selected: isFocused,
    component: "div",
    style: {
      fontWeight: isSelected ? 500 : 400
    },
    className: selectProps.classes.option
  }, innerProps), /*#__PURE__*/React.createElement(Text, {
    size: textSize
  }, children));
};